<template>
  <div class="update-modal feedback-slider">
    <div class="feedback-modal-custom">
    <div class="feedback-btn-content" v-for="(question,index) in data.qData" :key="index">
      <div v-if="qNumber === index" class="question-feedback">{{ question.question_text }}</div>
      <v-radio-group v-if="question.id === 1 && qNumber === index && data.target_year && data.target_year.length" v-model="targetExam" row class="ratting-radio">
        <v-radio class="exam-radio" v-for="exam in examList" :key="exam" :label="exam" :value="exam"></v-radio>
      </v-radio-group>
      <div class="err-color" v-if="question.id === 1 && errorMsg !== ''">{{errorMsg}}</div>
      <div v-if="question.id === 1 && qNumber === index && data.target_year && data.target_year.length" class="year-button-outer">
        <v-btn
          :class='data.target_year.length > 7 ? "year-button year-button-eight cust-btn feedback-submit year-text" : "year-button cust-btn feedback-submit year-text"' 
          v-for="year in data.target_year"
          :key="year.value"
          :style="{
            backgroundColor: feedbackText === year.value ? '#6ACAF3 !important' : '',
            color: feedbackText === year.value ? 'white !important' : 'black',
          }"
          @click="selectYear(year.value)"
          >{{ year.text }}</v-btn
        >
      </div>
      <div v-else-if="question.id === 2 && qNumber === index" class="slide-out-parent">
        <div class="ratting-slide">
          <div class="ratting-count-outer">
            <div class="ratting-count" v-for="count in countList" :key="count">
              {{ count }}
            </div>
          </div>
        </div>
        <div class="ratting-radio">
          <v-radio-group v-model="feedbackText" row>
            <v-radio
              v-for="count in countList"
              :value="count"
              :key="count"
            ></v-radio>
          </v-radio-group>
        </div>
        <div class="like-state">
          <div class="like-unlike">Unlikely</div>
          <div class="like-unlike">Highly like</div>
        </div>
      </div>
      <div v-else-if="question.id === 3 && qNumber === index" class="text-area-outer">
        <textarea v-model="feedbackText" maxlength ="500" class="feedback-area" rows="4" cols="50" required>Type here</textarea>
      </div>
      <div v-if="qNumber === index" class="feedback-outer">
        <v-btn
          class="right-btn cust-btn feedback-submit"
          color="primary"
          @click="feedBackSubmit(question.id, feedbackText, targetExam)"
        >
          SUBMIT</v-btn
        >
      </div>
    </div>
    <div class="err-color" v-if="errorFeedbackMsg">{{errorFeedbackMsg}}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import constants from '../../utils/constants';

export default {
  name: "FeedBackModal",
  props: ["onClose", "status", "data"],
  data() {
    return {
      countList: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"],
      feedbackText: null,
      qNumber: 0,
      examList: constants.TARGET_EXAM,
      targetExam: null,
      errorMsg: '',
      errorFeedbackMsg: ''
    };
  },
  methods: {
    ...mapActions({
      answerFeedback: "utilStore/answerFeedback",
    }),
    selectYear(year) {
      this.feedbackText = year;
    },
    feedBackSubmit(id) {
      if(this.validate(id)) {
        let reqData = {
          feedback_question_id: id,
          feedback: this.feedbackText.toString(),
          target_exam: this.targetExam
        };
        
        this.answerFeedback(reqData)
          .then((response) => {
            if (response) {
              this.feedbackText = '';
              this.errorFeedbackMsg = '';
              this.errorMsg='';
              this.qNumber = this.qNumber + 1;
              if(this.data && this.data.qData && this.data.qData.length === this.qNumber){
                this.onClose({status:false,showAutoSubmitPopup:true})
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    validate(id) {
      let isValid = true;
      if(id === 1 && !this.targetExam){            
        this.errorMsg = 'Please select target exam';
        isValid = false;
      }
      if(!this.feedbackText){
          if(id === 1){
            this.errorFeedbackMsg = 'Please select target year';
          }
          if (id === 2) {
            this.errorFeedbackMsg = 'Please give rating'
          }
          if (id === 3) {
            this.errorFeedbackMsg = 'Please enter feedback message'
          }
        isValid = false;
      }  
      return isValid;
    },
  },
};
</script>